import { Slide } from "@jelly/lesson";
import theory from "../../theory";
import config from "appConfig";

const principle: Slide = {
  description:
    "Here are presented 4 audio files. Each file plays a tone or a combination of tones to demonstrate the psychoacoustic “beating” effect.",
  theory: theory,
  layout: {
    type: "table",
    options: {
      cols: 2,
      rows: 4,
      rowsSize: [2, 6, 2, 6],
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  scrollbars: false,
                  formatter: "simple",
                  data: "1000 Hz",
                },
              },
              styles: {
                alignItems: "flex-end",
              },
            },
          },
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  scrollbars: false,
                  formatter: "simple",
                  data: "1000 Hz + 1002 Hz",
                },
              },
              styles: {
                alignItems: "flex-end",
              },
            },
          },
        ],
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "audioImage",
                options: {
                  imageSrc: `${config.ASSETS_URL}/02/04/principle/1000Hz.svg`,
                  audioUrl: `${config.ASSETS_URL}/02/04/principle/1000Hz.wav`,
                },
              },
            },
          },
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "audioImage",
                options: {
                  imageSrc: `${config.ASSETS_URL}/02/04/principle/1000Hz-1002Hz.svg`,
                  audioUrl: `${config.ASSETS_URL}/02/04/principle/1000Hz-1002Hz.wav`,
                },
              },
            },
          },
        ],
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  scrollbars: false,
                  formatter: "simple",
                  data: "1000 Hz + 1005 Hz",
                },
              },
              styles: {
                alignItems: "flex-end",
              },
            },
          },
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  scrollbars: false,
                  formatter: "simple",
                  data: "1000 Hz + 1020 Hz",
                },
              },
              styles: {
                alignItems: "flex-end",
              },
            },
          },
        ],
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "audioImage",
                options: {
                  imageSrc: `${config.ASSETS_URL}/02/04/principle/1000Hz-1005Hz.svg`,
                  audioUrl: `${config.ASSETS_URL}/02/04/principle/1000Hz-1005Hz.wav`,
                },
              },
            },
          },
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "audioImage",
                options: {
                  imageSrc: `${config.ASSETS_URL}/02/04/principle/1000Hz-1020Hz.svg`,
                  audioUrl: `${config.ASSETS_URL}/02/04/principle/1000Hz-1020Hz.wav`,
                },
              },
            },
          },
        ],
      ],
    },
  },
};

export default principle;
